// eslint-disable-next-line no-restricted-imports
import {
  default as Button,
  type ButtonProps as AntButtonProps
} from 'antd/es/button';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

export const PrimaryButton = forwardRef<HTMLButtonElement, AntButtonProps>(
  ({ ...props }, ref: ForwardedRef<HTMLButtonElement>) => {
    return <Button type="primary" ref={ref} {...props} />;
  }
);

PrimaryButton.displayName = 'PrimaryButton';
